import { Component, OnInit } from '@angular/core';
import {WorkFlowStageModel} from '../../shared/dto/work-flow-stage-model';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {OperationPrivilageModel} from '../../shared/dto/operation-privilage-model';
import {WorkflowStageService} from '../../shared/service/workflow-stage.service';
import {OperationPrivilageService} from '../../shared/service/operation-privilage.service';
import {Router} from '@angular/router';
import {SystemUserService} from '../../shared/service/system-user.service';
import swal from "sweetalert2";
import {UserRoleService} from '../../shared/service/userrole.service';
import {UserRoleModel} from '../../shared/dto/user-role.model';
import {TokenStorageService} from '../../shared/service/token-storage.service';

@Component({
  selector: 'app-assign-workflow-stage',
  templateUrl: './assign-workflow-stage.component.html',
  styleUrls: ['./assign-workflow-stage.component.scss']
})
export class AssignWorkflowStageComponent implements OnInit {

  target = [];
  source: WorkFlowStageModel[];
  systemUsers: UserRoleModel[] = [];
  isExist: boolean = false;
  public href: string = "";

  form: FormGroup;
  operationPrivilageModel: OperationPrivilageModel = new OperationPrivilageModel();
  public operationPriviledges: OperationPrivilageModel [] = [];
  public operationPrivilegesDTO: OperationPrivilageModel [] = [];

  constructor(
    private systemUserService: SystemUserService,
    private workflowStageService: WorkflowStageService,
    private operationPrivilageService: OperationPrivilageService,
    private userRoleService: UserRoleService,
    private tokenStorageService: TokenStorageService,
    private fb: FormBuilder,
    private router: Router) {
    this.form = this.fb.group({
      user: ['', [Validators.required]]
    });
  }

  ngOnInit() {
    this.href = this.router.url;
    this.getAllSystemUsers();
    this.getAllWorkflowStages();
    this.getAllOperationPrivileges();
  }

  get FormControls() {
    return this.form.controls;
  }

  public getAllOperationPrivileges() {
    this.operationPrivilageService.getAllOperationPrivileges().subscribe(
      (data: OperationPrivilageModel[]) => {
        this.operationPrivilegesDTO = data;
      }
    );
  }

  public getAllSystemUsers() {
    this.userRoleService.getAllUserRoles()
      .subscribe((result: UserRoleModel[]) => {
        this.systemUsers = result;
      });
  }

  public getAllWorkflowStages() {
    this.workflowStageService.getAllWorkflowStages()
      .subscribe((result) => {
        this.source = result;
      });
  }

  addAction() {
    for(let entry of this.target) {
      let i;
      for (i = 0; i < this.operationPriviledges.length; i++) {
        if (this.operationPrivilageModel.workflowStageCodes === this.operationPriviledges[i].workflowStageCodes &&
        this.operationPrivilageModel.userRole === this.operationPriviledges[i].userRole) {
          swal.fire('Duplicate record','' , 'warning');
          this.isExist = true;
        }
        if (this.target[i].workflowStageCodes === this.operationPrivilageModel.workflowStageCodes ) {
          this.isExist = true;
        }
        if (this.operationPrivilageModel.workflowStageCodes === this.operationPrivilegesDTO[i].workflowStageCodes) {
          swal.fire('Already Exist','' , 'warning');
          this.isExist = true;
        }
      }
    }

    if(!this.isExist) {
      this.operationPrivilageModel.userRole = this.form.controls.user.value;
      this.operationPrivilageModel.workflowStageCodes = this.target;
      this.operationPrivilageModel.lastUpdatedUser = this.tokenStorageService.getUserObjectToken().username;
      this.operationPrivilageModel.url = this.href;
      this.operationPriviledges.push(this.operationPrivilageModel);
    }
  }

  onSave() {
    this.operationPrivilageModel.userRole = this.form.controls.user.value;
    this.operationPrivilageModel.workflowStageCodes = this.target;
    this.operationPrivilageModel.lastUpdatedUser = this.tokenStorageService.getUserObjectToken().username;
    this.operationPrivilageModel.url = this.href;
    swal.fire({
      title: "Are you sure, you want to submit?",
      text: "",
      showCancelButton: true,
      confirmButtonText: "Yes"

    }).then((result) => {
        if (result.value) {
          this.operationPrivilageService.addOperationPrivilage(this.operationPrivilageModel).subscribe(
            (res: boolean) => {
              if (res === true) {
                swal.fire("Success", "Details submitted successfully", "success");
                this.target = [];
              }
            },
            (error) => {
              console.log(error);
              swal.fire("Sorry!", "Something went wrong...!", "error");
            },
            () => {
            }
          );
        }
      }, reason => {
      }
    );
  }

  getCurrentUser(selectedUser: string) {
    // console.log('value is ', selectedUser);
    this.operationPrivilageService.getByUser(selectedUser)
      .subscribe((result: OperationPrivilageModel[]) => {
        if (result) {
          for(let results of result){
            this.target = results.workflowStageCodes;
          }
          this.operationPriviledges = result;
        } else {
          console.log('Error occured...');
        }
      });
  }


}
